import React from 'react';
import PropTypes from 'prop-types';

import Draw from '../../Components/Mapbox/Draw/Draw';

function withDrawControlLite (WrappedComponent) {
    class WithDrawControlLite extends React.Component {
        static propTypes = {
            id: PropTypes.string.isRequired,
            drawControls: PropTypes.object.isRequired,
            drawnFeatures: PropTypes.any,
            // callbacks
            onMapLoaded: PropTypes.func,
            onDrawLoaded: PropTypes.func,
            onFeatureChange: PropTypes.func
        };

        static defaultProps = {

        };

        constructor (props) {
            super(props);

            this.draw = null;
            this.drawControl = null;

            this.handleMapLoaded = this.handleMapLoaded.bind(this);
            this.setDrawnFeatures = this.setDrawnFeatures.bind(this);
            this.handleFeatureChange = this.handleFeatureChange.bind(this);
        }

        componentDidUpdate = async (prevProps, prevState) => {
            const { drawnFeatures } = this.props;
            if (prevProps.drawnFeatures !== drawnFeatures) { this.setDrawnFeatures(drawnFeatures); }
        };

        handleMapLoaded (map) {
            const { drawControls, drawEvents, drawnFeatures, onMapLoaded, onDrawLoaded, drawStyles } = this.props;
            this.draw = new Draw({
                map,
                drawControls: drawControls,
                updateDrawnFeature: this.handleFeatureChange,
                drawStyles: drawStyles
            });
            this.drawControl = this.draw.getDrawControl();

            map.addControl(this.drawControl, 'top-right');

            if (drawEvents) {
                const eventKeys = Object.keys(drawEvents);
                for (const eventKey of eventKeys) {
                    map.on(eventKey, drawEvents[eventKey]);
                }
            }

            if (drawnFeatures) { this.setDrawnFeatures(drawnFeatures); }

            onMapLoaded && onMapLoaded(map);
            onDrawLoaded && onDrawLoaded(this.draw);
        }

        setDrawnFeatures (drawnFeatures) {
            if (this.drawControl) {
                this.drawControl.set(drawnFeatures);
                const selectedIds = this.drawControl.getAll().features
                    .filter(feature => feature.properties.active === 'true')
                    .map(feature => feature.id);
                this.drawControl.changeMode('simple_select', { featureIds: selectedIds });
            }
        }

        handleFeatureChange = feature => {
            const { onFeatureChange } = this.props;
            onFeatureChange && onFeatureChange(feature);
        };

        render () {
            const { onFeatureChange, onDrawModeChange, drawControls, drawnFeatures, ...props } = this.props;
            return (
                <WrappedComponent
                    {...this.props}
                    onMapLoaded={this.handleMapLoaded}
                />
            );
        }
    }

    const wrappedComponentName = WrappedComponent.displayName
        || WrappedComponent.name
        || 'Component';

    WithDrawControlLite.displayName = `withDrawControlLite(${wrappedComponentName})`;
    return WithDrawControlLite;
}

export default withDrawControlLite;